define('GameDayCore/GDModel/ValueObjects/Gamecenter/TeamVsPitcher5Y',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(TeamVsPitcher5Y);

	function TeamVsPitcher5Y($data) {
		var vo = VO.ensureVO(this, TeamVsPitcher5Y),
			data = $data;

			vo.rows = data.queryResults.row;
	}

	return TeamVsPitcher5Y;
});
